module.exports = __webpack_public_path__ + "static/media/GilbertSolisResume.42b1f0e0.pdf";